var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/"}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("mdi-"+_vm._s(_vm.iconType))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }